// extracted by css-extract-rspack-plugin
export default {"scroller":"Scroller-module__scroller--VypuO"};